<template>
  <div class="" >
    <top-header :type="6" :hasBorder="true" :placeholder="'预售详情'" :bgColor="'#fff'" fontSize="0.32rem" />
    <img class="pic" v-if="objs.salePermitId"  :src="imgPath + 'sImgSale/' + objs.salePermitId + '.jpg'"  alt="">
    <img class="pic" v-else-if="!objs.salePermitId"   src="@/assets/img/default_house_list.jpg"  alt="">
    <div class="text_con" >
      <h3>预售详情信息</h3>
      <div class="inner" >
        <p class="row m_flex_box">
          <span class="tit">行政区：</span>
          <span class="text">{{objs.district ? objs.district : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">区位：</span>
          <span class="text">{{objs.zone ? objs.zone : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">开发公司：</span>
          <span class="text">{{objs.corpName ? objs.corpName : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">施工许可：</span>
          <span class="text">{{objs.constructCertNo ? objs.constructCertNo : '-'}}</span>
        </p>
      </div>
      <div class="inner">
        <p class="row m_flex_box">
          <span class="tit">立项批文：</span>
          <span class="text">{{objs.itAcPaper ? objs.itAcPaper : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">用地许可：</span>
          <span class="text">{{objs.certifyPlanLand ? objs.certifyPlanLand : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">土地用途：</span>
          <span class="text">{{objs.landUse ? objs.landUse : '-'}}</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">土地证号：</span>
          <span class="text">{{objs.certNo ? objs.certNo : '-'}}</span>
        </p>
      </div>
      <div class="inner">
        <p class="row m_flex_box">
          <span class="tit">土地面积：</span>
          <span class="text">{{objs.landArea ? objs.landArea : '-'}} ㎡</span>
        </p>
        <p class="row m_flex_box">
          <span class="tit">规划用途：</span>
          <span class="text">{{objs.planUse ? objs.planUse : '-'}}</span>
        </p>
      </div>
    </div>
    </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from "qs";
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      saleItemId:'',
      objs:''
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getRequest();
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.$new.post('salePermit/getYsxxBySaleId.do', qs.stringify({
        saleItemId: this.saleItemId
      })).then(res => {
        if(res.success) {
          this.objs = res.obj;
          var imgUrl=this.imgPath + 'sImgSale/' + res.obj.salePermitId + '.jpg'
          this.loading = false;
          this.finished = true;
          this.$new.post('itemInfo/getItemSimple.do',qs.stringify({
            itemId: res.obj.itemid
          })).then(request => {
            var dec=res.obj.district+request.obj.xmmc
            this.$share(res.obj.certificateNo,dec,imgUrl)
          })
        } else {
          this.finished = true;
        }
      })
    },

    getRequest(){
      this.saleItemId =  this.$route.query.saleItemId;
    }
  }
};
</script>
<style lang="less" scoped>
  .pic{
    width: 100%;
    height: 5.68rem;
  }
  h3{
    font-weight: 800;
    font-size: 0.34rem;
    color: #1C1C1C;
    margin-bottom: 0.1rem;
  }
  .text_con{
    margin: 0.4rem auto 0rem;
    width: 7.04rem;
  }
  .inner{
    padding: 0.3rem 0;
    font-size: 0.26rem;
    border-bottom: 1px solid #f5f5f5;
    p{
      margin-bottom: 0.12rem;
      line-height: 0.42rem;
      &:last-child{
        margin-bottom: 0;
      }
    }
    .tit{
      width: 1.8rem;
      padding-right: 0.3rem;
      box-sizing: border-box;
      text-align: right;
      color: #909090;
    }
    .text{
      width: 80%;
    }
  }
</style>